import { english } from "./en/index";
import { thai } from "./th/index";
export const messages = {
  en: {
    ...english,
  },
  th: { ...thai },
};
